export default __webpack_public_path__ + "static/media/3 - Misión, visión y servicio al cliente.560f113f.mp4";